import React, { useState } from 'react';
import { CheckCircle, X, AlertCircle, Info, XCircle } from 'lucide-react';

const NotificationBanner = ({ 
  message = "Lorem ipsum dolor sit amet, consetetur sadipscing",
  variant = "success",
  dismissible = true,
  onClose 
}) => {
  const [isVisible, setIsVisible] = useState(true);

  const variants = {
    success: {
      iconColor: "#4ade80",
      Icon: CheckCircle
    },
    error: {
      iconColor: "#f87171",
      Icon: XCircle
    },
    warning: {
      iconColor: "#facc15",
      Icon: AlertCircle
    },
    info: {
      iconColor: "#60a5fa",
      Icon: Info
    }
  };

  const currentVariant = variants[variant] || variants.success;
  const { iconColor, Icon } = currentVariant;

  const handleClose = () => {
    setIsVisible(false);
    if (onClose) {
      onClose();
    }
  };

  if (!isVisible) return null;

  return (
    <div style={{
      backgroundColor: "#334155",
      borderRadius: "0.5rem",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
      padding: "1rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "1rem",
      maxWidth: "70rem",
      margin: "0 auto",
      pointerEvents: "none",
      userSelect: "none"
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        flex: "1"
      }}>
        <div style={{
          color: iconColor,
          backgroundColor: `${iconColor}33`,
          borderRadius: "9999px",
          padding: "0.5rem",
          flexShrink: "0",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
          <Icon size={24} color={iconColor} />
        </div>
        <p style={{
          color: "white",
          fontSize: "1.125rem",
          fontWeight: "300",
          margin: "0"
        }}>
          {message}
        </p>
      </div>

      {dismissible && (
        <button
          onClick={handleClose}
          style={{
            color: "#9ca3af",
            backgroundColor: "transparent",
            border: "none",
            cursor: "pointer",
            flexShrink: "0",
            padding: "0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "color 0.2s",
            pointerEvents: "auto"
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = "white"}
          onMouseLeave={(e) => e.currentTarget.style.color = "#9ca3af"}
          aria-label="Close notification"
        >
          <X size={24} />
        </button>
      )}
    </div>
  );
};

export default NotificationBanner;